const DARK_QUERY = '(prefers-color-scheme: dark)';

/**
 * Aplica o tema escuro (`.dark` no elemento raiz) conforme a preferência do sistema e
 * acompanha mudanças. Devolve a função que encerra o acompanhamento.
 */
export function syncColorScheme(
  root: HTMLElement = document.documentElement,
  media: MediaQueryList = window.matchMedia(DARK_QUERY),
): () => void {
  const apply = (): void => {
    root.classList.toggle('dark', media.matches);
  };
  apply();
  media.addEventListener('change', apply);
  return () => {
    media.removeEventListener('change', apply);
  };
}
